(function () {
  function setHeight(content, isOpen) {
    if (!content) return;
    if (isOpen) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      requestAnimationFrame(function () {
        content.style.maxHeight = '0px';
      });
    }
  }

  function openInitial(root) {
    root.querySelectorAll('[data-faq-b2b-item].is-open').forEach(function (item) {
      var content = item.querySelector('[data-faq-b2b-content]');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
    });
  }

  function init(root) {
    if (!root || root.dataset.faqB2bInit === 'true') return;
    root.dataset.faqB2bInit = 'true';

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-faq-b2b-trigger]');
      if (!trigger || !root.contains(trigger)) return;

      var item = trigger.closest('[data-faq-b2b-item]');
      if (!item) return;

      var content = item.querySelector('[data-faq-b2b-content]');
      var willOpen = !item.classList.contains('is-open');

      item.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      setHeight(content, willOpen);
    });

    openInitial(root);

    root.addEventListener('transitionend', function (event) {
      if (event.propertyName !== 'max-height') return;
      var content = event.target;
      if (!content.matches('[data-faq-b2b-content]')) return;
      var item = content.closest('[data-faq-b2b-item]');
      if (item && item.classList.contains('is-open')) {
        content.style.maxHeight = 'none';
      }
    });
  }

  function bootAll() {
    document.querySelectorAll('[data-faq-b2b-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('[data-faq-b2b-root]').forEach(init);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-faq-b2b-item].is-open [data-faq-b2b-content]').forEach(function (content) {
      content.style.maxHeight = 'none';
    });
  });
})();
